import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { finalize, Observable, ReplaySubject, takeUntil } from 'rxjs';
import { IIdValue } from '../../types/id-value.interface';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';

@Component({
  selector: 'korviu-multi-select',
  standalone: true,
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    TranslateModule,
    NzIconModule
  ],
  templateUrl: './korviu-multi-select.component.html',
  styleUrls: ['./korviu-multi-select.component.scss']
})
export class KorviuMultiSelectComponent implements OnInit, OnDestroy {
  @Input() public label: string;
  @Input() public disabled: boolean;
  @Input() public options: IIdValue[];
  @Input() public originalOptions: IIdValue[];
  @Input() public serverOptions: any[];
  @Input() public selectedValues: IIdValue[];
  @Input() public serverSearch: boolean;
  @Input() public searchFn: (searchText: string) => Observable<IIdValue[]>;
  @Input() public dropdownLabelFormatFn: (item: any) => string;
  @Input() public chipsLabelFormatFn: (item: any) => string;
  @Output() public selectedValuesChange: EventEmitter<IIdValue[]>;
  @Input() public currentSelectValue!: number;
  @Output() public currentSelectValueChange: EventEmitter<number>;

  public availableOptions: IIdValue[];
  public searchIsLoading: boolean;

  public searchFieldIsFocused: boolean;
  public get searchFieldIsActive(): boolean {
    return this.searchFieldIsFocused || !!this.currentSelectValue;
  }

  private _searchTimeout: number | any;
  private readonly _onDestroy$: ReplaySubject<void>;

  constructor() {
    this.serverOptions = [];
    this.searchFieldIsFocused = false;
    this._searchTimeout = null;
    this.searchIsLoading = false;
    this.serverSearch = false;
    this.label = 'Select values';
    this.options = [];
    this.originalOptions = [];
    this.availableOptions = [];
    this.currentSelectValue = null;
    this.disabled = false;
    this.selectedValues = [];
    this.selectedValuesChange = new EventEmitter<IIdValue[]>();
    this.currentSelectValueChange = new EventEmitter<number>();
    this._onDestroy$ = new ReplaySubject<void>(1);
  }

  public ngOnInit(): void {
    this._updateAvailableOptions();
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public prefillField(value: any): void {
    this.currentSelectValue = value?.id;
    this.serverOptions.push(value);
  }

  public onFocus(): void {
    this.searchFieldIsFocused = true;
  }

  public onBlur(): void {
    this.searchFieldIsFocused = false;
  }

  public onSearch(searchText: string): void {
    if (!searchText) {
      return;
    }
    if (this._searchTimeout) {
      clearTimeout(this._searchTimeout);
    }
    this._searchTimeout = setTimeout(() => {
      this._searchPeople(searchText);
    }, 1000);
  }

  public onSelectModelChange(value: any): void {
    this.currentSelectValueChange.emit(value);
    /*if (this.serverSearch) {
			setTimeout(() => {
				this.currentSelectValue = null;
			});
			if (this.selectedValues.find((option: IIdValue) => option.id === value)) {
				return;
			}
			this.selectedValues.push(this.serverOptions.find((option: IIdValue) => option.id === value));
		} else {
			this.selectedValues.push(this.originalOptions.find((option: IIdValue) => option.id === value));
			setTimeout(() => {
				this.currentSelectValue = null;
				this._updateAvailableOptions();
			});
		}*/
  }

  public onBusinessValueDelete(value: IIdValue): void {
    this.selectedValues = this.selectedValues.filter((selectedValue: IIdValue) => selectedValue?.id !== value?.id);
    this._updateAvailableOptions();
  }

  private _searchPeople(text: string): void {
    this.searchIsLoading = true;
    this.searchFn(text)
      .pipe(
        finalize(() => {
          this.searchIsLoading = false;
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe((values: any) => {
        this.serverOptions = values;
      });
  }

  private _updateAvailableOptions(): void {
    const selectedValuesIds: number[] = this.selectedValues.map((value: IIdValue) => +value.id);
    this.options = this.originalOptions.filter(
      (availableValue: IIdValue) => !selectedValuesIds.includes(+availableValue.id)
    );
    this.selectedValuesChange.emit(this.selectedValues);
  }
}
